import { extend, $, $$, addEvent } from './helper-functions'

export class RealEstateDetailVariant1 {
  constructor (settings, selectors, classes) {
    this.settings = extend({}, settings)

    this.selectors = extend({
      block: '.real-estate-detail--variant-1',
      mediaControls: '[data-red-media-target]',
      mediaTargets: '[data-red-media]',
      gallery: '.gallery',
      galleryCurrent: '.real-estate-detail__gallery-current',
      buttonContactForm: '[data-red-contact-form]',
      contactForm: '.real-estate-detail__contact-form',
      contactActions: '.real-estate-detail__contact-actions'
    }, selectors)

    this.classes = extend({
      active: 'is--active'
    }, classes)

    this.reds = $$(this.selectors.block)
  }

  init () {
    this.events()
  }

  events () {
    this.reds.forEach(red => {
      const mediaControls = $$(this.selectors.mediaControls, red)
      const mediaTargets = $$(this.selectors.mediaTargets, red)
      const gallery = $(this.selectors.gallery, red)
      const galleryCurrent = $(this.selectors.galleryCurrent, red)
      const contactForm = $(this.selectors.contactForm, red)
      const contactActions = $(this.selectors.contactActions, red)
      const buttonsContactForm = $$(this.selectors.buttonContactForm, red)

      mediaControls.forEach(mediaControl => {
        addEvent(mediaControl, 'click', (event) => {
          const mediaControlTarget = mediaControl.dataset.redMediaTarget

          mediaControl.classList.add(this.classes.active)

          mediaTargets.forEach(mediaTarget => {
            if (mediaControlTarget === mediaTarget.dataset.redMedia) {
              mediaTarget.classList.add(this.classes.active)
            } else {
              mediaTarget.classList.remove(this.classes.active)
            }
          })

          mediaControls.forEach(mediaControl2 => {
            if (mediaControl !== mediaControl2) {
              mediaControl2.classList.remove(this.classes.active)
            }
          })
        })
      })

      addEvent(gallery, 'update', () => {
        galleryCurrent.textContent = gallery.dataset.galleryCurrent
      })

      buttonsContactForm.forEach(buttonContactForm => {
        addEvent(buttonContactForm, 'click', (event) => {
          if (buttonContactForm.dataset.redContactForm === '1') {
            contactForm.classList.add(this.classes.active)
            contactActions.classList.remove(this.classes.active)
          } else {
            contactForm.classList.remove(this.classes.active)
            contactActions.classList.add(this.classes.active)
          }
        })
      })
    })
  }
}

export default RealEstateDetailVariant1
